'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../node_modules/tslib/tslib.es6.js');
var React = require('react');
var index = require('../../../node_modules/classnames/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var RadioGroup = function (props) {
    var id = props.id, groupAlignment = props.groupAlignment, children = props.children;
    var handleChange = function (event) { return event; };
    return (React__default['default'].createElement("div", { id: id, className: index['default']('d-flex', [groupAlignment === 'horizontal' ? 'flex-direction-horizontal' : 'flex-direction-vertical']) }, React__default['default'].Children.map(children, function (item) {
        if (item) {
            var className = item.props.className;
            var props_1 = tslib_es6.__assign(tslib_es6.__assign({}, item.props), { className: className, onChange: handleChange });
            return React__default['default'].cloneElement(item, props_1, item.props.children);
        }
    })));
};

exports.RadioGroup = RadioGroup;
//# sourceMappingURL=RadioGroup.js.map
